import { createSlice } from "@reduxjs/toolkit";

const address = {
  city: "",
  county: "",
  zipCode: "",
  address1: ""
};

const studentFamilyMember = {
  isDead: false,
  tcKimlikNo: "",
  name: "",
  surname: "",
  occupation: "",
  phone1: "",
  phone2: "",
  email: "",
  relationship: "",
  occupationCategories: [],
  educationalBackground: {
    university: "",
    department: "",
    graduationYear: ""
  },
  workAddress: address,
  homeAddress: address
};

const initialStudent = {
  registrationNo: "",
  registrationDate: "",
  studentNumber: "",
  theSchoolWhereComeFrom: "",
  phone: "",
  email: "",
  facebook: "",
  twitter: "",
  identityCard: {
    tcKimlikNo: "",
    name: "",
    surname: "",
    birthDate: "",
  },
  father: studentFamilyMember,
  mother: studentFamilyMember,
  other: studentFamilyMember,
  registrationInfo: {
    term: 0,
    sections: [],
    willUseCafeteria: true,
    bougthUniform: true,
    uniformExplanation: "",
    bougthBook: true,
    bookExplanation: ""
  },
  invoiceInfo: {
    personOrCompanyName: "",
    personTC: "",
    taxOffice: "",
    taxNumber: "",
    address: address
  }
};

const initialStudentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  familyMembers: [],
  sections: [],
  student: initialStudent
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentSlice = createSlice({
  name: "students",
  initialState: initialStudentsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getAllSections
    allSectionsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.sections = action.payload.entities;
    },
    // getFamilyMembers
    familyMembersFetched: (state, action) => {
      state.actionsLoading = false;
      state.familyMembers = action.payload;
    },
    // getSections
    sectionsFetched: (state, action) => {
      state.actionsLoading = false;
      state.sections = action.payload;
    },
    //getStudent
    studentFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.student = action.payload.entity;
      state.sections = action.payload.entity && action.payload.entity.registrationInfo.sections;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanStudentsState
    studentsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.familyMembers = [];
      state.totalCount = 0;
      state.entities = undefined;
      state.student = initialStudent;
    }
  }
});